<template>
  <PageSecondary>
    <template #title>Любовь, основа</template>

    <h4>Базовые принципы отношений</h4>

    <p>
      Речь о любых отношениях
    </p>

    <ul>
      <li>Отношения с родителями</li>
      <li>С самим собой</li>
      <li>Со случайными встречными</li>
      <li>С друзьями</li>
      <li>С парой.</li>
    </ul>

    <p>Я озвучу принципы, и потом подробно раскрою каждый из них. Этот список можно использовать как чек-лист.</p>

    <ul>
      <li>Учись. Никто не друг, никто не враг, но каждый мой учитель.</li>
      <li>Слушай. Без суждений смотри, слушай, наблюдай.</li>
      <li>Дари. Дари с радостью, но не ожидай ответа.</li>
      <li>Принимай. Принимай подарки и испытания, не вешай камень долга.</li>
      <li>Прояви. Озвучь дискомфорт, дай волю импульсу.</li>
      <li>Нейтральность. Зло есть только в твоём восприятии.</li>
    </ul>

    <p>
      Окружающий нас мир будет отражать наш внутренний мир. Атмосфера в семье в детстве создала наш внутренний театр.
      Теперь внутренний театр создаёт наши отношения на работе и с парой.
    </p>

    <p>
      Любая существующая реальность имеет потенциал и стремление расцвести. Ситуации повторяются, чтобы ты нашёл новый
      подход. Этот процесс расцвета можно ускорить применяя принципы, озвученные выше.
    </p>

    <p>
      Принципы выше помогают перестать затягивать узлы. Помогают замечать огонь до того как металл засветился белым. Но
      они не волшебство, которое мигом преобразит всю вокруг. Твоя жизнь была отлажена вокруг имеющихся стратегий.
      Потребуется время, забота и терпение, чтобы новые семена взошли, окрепли и расцвели.
    </p>

    <p>
      Эти принципы лучше всего начать применять сразу на всех уровнях, уровне внутреннего диалога и отношения к себе, и
      уровня отношений с другими. Причём первое время вероятно стойкое ощущение фальшивости, это нормально.
    </p>

  </PageSecondary>
</template>

<script>
import PageSecondary from "@/components/PageSecondary";
export default {
  name: "LoveBase",
  components: {PageSecondary}
}
</script>

<style scoped>

</style>